import { router } from '@inertiajs/react'
import { useI18n } from '../lib/useI18n'
import Select from './components/Select'

// Locale switcher (architecture §6.11). Posts the choice to /locale (persisted on
// the user + a cookie) and reloads so the server re-resolves the locale. Shared
// by both shells; the option labels use each locale's own endonym.
const LABELS: Record<string, string> = {
  en: 'English',
  'zh-TW': '繁體中文',
}

export default function LocaleSwitcher() {
  const { locale, available_locales, t } = useI18n()

  function change(next: string) {
    if (next === locale) return
    router.post('/locale', { locale: next }, { preserveScroll: true })
  }

  return (
    <Select
      ariaLabel={t('app.common.language')}
      className="w-36"
      value={locale}
      onChange={change}
      options={available_locales.map((code) => ({ value: code, label: LABELS[code] ?? code }))}
    />
  )
}
